import { useMemo, useRef } from "react";
import { useSelector } from "react-redux";
import { useParams } from "react-router-dom";
import { StyledNavbarContainerDiv, StyledNavbarItemSpan } from "./index.styles";
import { CatalogueNavbarSkeleton } from "../components/skeleton";
import { selectPortalId } from "../../../../store/slice/portalContextSlice";
import { useGetPortalBuyerCategoriesQuery } from "../../../../store/apiSlice/portalCatalogueApiSlice";

export const CatalogueNavbar = ({ activeCategoryId, onCategoryChange }) => {
  const { subdomain } = useParams();
  const portalId = useSelector(state => selectPortalId(state, subdomain));
  const navbarRef = useRef(null);

  const { data: categories = [], isLoading } = useGetPortalBuyerCategoriesQuery(undefined, {
    skip: !portalId,
  });

  const categoriesWithChildren = useMemo(() => {
    const categoryData = [];
    categories.forEach(cat => {
      categoryData.push(cat);
      if (cat.children?.length > 0) {
        categoryData.push(...cat.children);
      }
    });
    return categoryData;
  }, [categories]);

  if (!portalId || isLoading) {
    return <CatalogueNavbarSkeleton />;
  }

  return (
    <StyledNavbarContainerDiv ref={navbarRef}>
      <StyledNavbarItemSpan className={activeCategoryId === null ? "active" : ""}>
        <span onClick={() => onCategoryChange(null)}>All Products</span>
      </StyledNavbarItemSpan>

      {categoriesWithChildren.map(category => (
        <StyledNavbarItemSpan
          key={category.id}
          className={activeCategoryId === category.id ? "active" : ""}
        >
          <span onClick={() => onCategoryChange(category.id)}>{category.name}</span>
        </StyledNavbarItemSpan>
      ))}
    </StyledNavbarContainerDiv>
  );
};
